// extracted by mini-css-extract-plugin
export default {"section":"Yoga_section__Evesv"};